import SiteMap from "./site-map";
import SiteMapNavigation from "./site-map-navigation";

export default class SiteMapOverlay extends HTMLElement {

    siteMap;
    navigation;
    toggleButton;

    constructor() {
        super();

        const config = this.prepareConfig();

        this.siteMap = new SiteMap(config);
        this.appendChild(this.siteMap);

        this.navigation = new SiteMapNavigation(config.navigation, this.siteMap);
        this.appendChild(this.navigation);

        this.initButton();
    }

    initButton() {
        let template = document.querySelector('template#site-map-button');
        if (template == null) {
            template = document.createElement('template');
            template.innerHTML = buttonTemplate;    
        }

        let button = template.content.cloneNode(true);

        this.appendChild(button);
        button = this.lastElementChild;

        button.addEventListener('click', (event) => {
            event.preventDefault();
            this.toggle();
        }); 
    }

    async connectedCallback() {

    }

    toggle() {
        this.siteMap.hidden ? this.siteMap.show() : this.siteMap.hide();
    }

    prepareConfig() {
        const siteMapConfig = document.getElementById('site-map-config');
        if (siteMapConfig == null)
            return {};
    
        const configObject = JSON.parse(siteMapConfig.innerText);
        let hoverAnimation = {};
        let hoverLinks = {};
        const path = window.location.toString().replace(document.baseURI, '');
        let currentModel = '';
        configObject.interactables?.forEach((item) => {
            hoverAnimation[item.object] = item.animation;
            hoverLinks[item.object] = item.link;
    
            if (path == item.link)
                currentModel = item.object;
        });
    
        return {
            scene: configObject.path ?? 'objects/map.json',
            activeColor: configObject.activeColor ?? '0xff00ff',
            currentModel: currentModel,
            hoverAnimations: hoverAnimation,
            hoverLinks: hoverLinks,
            navigation: configObject.navigation ?? {}
        }
    }
}

const buttonTemplate = `
<button id="site-map-button" type="button" class="sitemap-button">
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
        <path d="M13.125 16.625L7.875 14.7787V4.375L13.125 6.22125M17.9375 2.625C17.885 2.625 17.8413 2.625 17.7975 2.625L13.125 4.4625L7.875 2.625L2.94 4.2875C2.75625 4.34875 2.625 4.50625 2.625 4.7075V17.9375C2.625 18.0535 2.67109 18.1648 2.75314 18.2469C2.83519 18.3289 2.94647 18.375 3.0625 18.375C3.10625 18.375 3.15875 18.375 3.2025 18.3487L7.875 16.5375L13.125 18.375L18.06 16.7125C18.2437 16.625 18.375 16.4938 18.375 16.2925V3.0625C18.375 2.94647 18.3289 2.83519 18.2469 2.75314C18.1648 2.67109 18.0535 2.625 17.9375 2.625Z" fill="white"></path>
    </svg>
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"></path>
    </svg>
</button>
`;